angular.module('CarsSaraBo').factory('BookingService', ['$resource', function($resource) {
    return $resource('../rest/company/:companyOID/booking',
        {
            companyOID : '@companyOID'
        },
        {
            query: {method:'GET', isArray : true},
            queryPage: {method:'GET', isArray : false}
        }
    )}
]);


angular.module('CarsSaraBo').factory('BookingService_Desp', ['$resource', function($resource) {
    return $resource('../rest/company/booking',
        null,
        {
            query: {method:'GET', isArray : true},
            queryPage: {method:'GET', isArray : false}
        }
    )}
]);

angular.module('CarsSaraBo').factory('BookingReport', ['$resource', function($resource) {
    return $resource('../rest/company/:companyOID/booking/downloadExcel',
        {
            companyOID : '@companyOID'
        },
        {
            queryReport: {method:'GET', isArray : false}
        }
    )}
]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/booking_service.js
// module id = 838
// module chunks = 3